import NextRouter from 'next/router';

import {buildUrl} from './build-url';
import {withSectionQuery} from './section-query';
import {RouteName, RouteParams} from './table';

type Options = {
	shallow?: boolean;
	scroll?: boolean;
	locale?: string | false;
	/** переносить query текущего адреса при переходе внутри раздела; по умолчанию переносится */
	keepQuery?: boolean;
};

function urlOf<K extends RouteName>(name: K, params?: RouteParams<K>, keepQuery = true) {
	const current = typeof window === 'undefined' ? undefined : NextRouter.router?.asPath;
	return buildUrl(name, keepQuery ? withSectionQuery(current, name, params) : params);
}

/** Переход на именованный маршрут: `navigate('class', {id})`. */
export function navigate<K extends RouteName>(name: K, params?: RouteParams<K>, options?: Options) {
	const {keepQuery, ...routerOptions} = options || {};
	return NextRouter.push(urlOf(name, params, keepQuery), undefined, routerOptions);
}

/** Замена текущей записи истории именованным маршрутом. */
export function replaceRoute<K extends RouteName>(name: K, params?: RouteParams<K>, options?: Options) {
	const {keepQuery, ...routerOptions} = options || {};
	return NextRouter.replace(urlOf(name, params, keepQuery), undefined, routerOptions);
}

/** Предзагрузка страницы маршрута. */
export function prefetchRoute<K extends RouteName>(name: K, params?: RouteParams<K>) {
	return NextRouter.prefetch(buildUrl(name, params));
}
